var _style, _path, _path2, _path3, _ellipse, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 521.3 666",
    style: {
      enableBackground: "new 0 0 521.3 666"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .st0 {\n      fill: #81cdff;\n    }\n    .skin-dark {\n      fill: #d8aa88;\n    }\n    .skin {\n      fill: #ecbc94;\n    }\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M521.3,666H0c25-125.8,132.2-220.4,260.7-220.4S496.3,540.2,521.3,666z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "skin-dark",
    d: "M274.5,550h-28.8c-38.4,0-68.2-29.1-63.6-62.1l6.2-44.9h143.5l6.2,44.9C342.6,520.9,312.9,550,274.5,550z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "skin",
    d: "M402.7,453H124c-26.6,0-49.2-20.9-50.4-47.1L63.7,69c-1.4-31.1,21.4-56.7,51-56.7l293.9,1 c29.6,0,52.4,25.5,51,56.7l-6.4,335.9C451.9,432.1,429.3,453,402.7,453z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3079 -0.9514 0.9514 0.3079 128.5067 600.699)",
    className: "skin",
    cx: 477.1,
    cy: 212,
    rx: 68,
    ry: 39.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9507 -0.3102 0.3102 0.9507 -65.8649 25.1275)",
    className: "skin",
    cx: 46.1,
    cy: 219.6,
    rx: 39.5,
    ry: 68
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset11);
export default __webpack_public_path__ + "static/media/Asset 11.fcb64df2.svg";
export { ForwardRef as ReactComponent };